export default function isNaN(valeur) {
  return Number.isNaN(valeur) || typeof valeur !== 'number';
}
